import { useState, useCallback, useEffect } from 'react'

function isFunction(obj) {
  return typeof obj === 'function'
}

export function createUseStorageState(nullishStorage) {
  function useStorageState(key, defaultValue) {
    const storage = nullishStorage
    const [state, setState] = useState(() => getStoredValue())
    useEffect(() => {
      setState(getStoredValue())
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key])

    function getStoredValue() {
      const raw = storage.getItem(key)
      if (raw) {
        try {
          if (raw && !raw.includes('"')) {
            return raw
          }
          return JSON.parse(raw)
        } catch (e) {
          console.log(e)
        }
      }
      if (isFunction(defaultValue)) {
        return defaultValue()
      }
      return defaultValue
    }

    const updateState = useCallback(
      (value) => {
        if (typeof value === 'undefined') {
          storage.removeItem(key)
          setState(undefined)
        } else if (isFunction(value)) {
          const previousState = getStoredValue()
          const currentState = value(previousState)
          if (typeof currentState === 'string') {
            storage.setItem(key, currentState)
          } else {
            storage.setItem(key, JSON.stringify(currentState))
          }

          setState(currentState)
        } else {
          if (typeof value === 'string') {
            storage.setItem(key, value)
          } else {
            storage.setItem(key, JSON.stringify(value))
          }
          setState(value)
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [key],
    )

    return [state, updateState]
  }
  if (!nullishStorage) {
    return function (defaultValue) {
      return [isFunction(defaultValue) ? defaultValue() : defaultValue, () => {}]
    }
  }
  return useStorageState
}

export const useSessionStorage = createUseStorageState(
  typeof window === 'object' ? window.sessionStorage : null,
)
